export default "__VITE_ASSET__YFvjReo$__"